import { useState } from 'react'
import Chat from '../chat/Chat'
import Feed from '../feed/Feed'
import PillSwitcher from './PillSwitcher/PillSwitcher'
import WeeklyShortlist from './WeeklyShortlist/WeeklyShortlist'
import GraphView from '../GraphView/GraphView'
import layout from './Home.module.css'

const DashHome = () => {
  const [activeView, setActiveView] = useState('feed')

  const handleViewChange = (view) => {
    setActiveView(view)
  }

  return (
    <div className={layout.homeContainer}>
      <PillSwitcher activeView={activeView} onViewChange={handleViewChange} />

      {activeView === 'graph' ? (
        <div className={layout.shortlistView}>
          <GraphView />
        </div>
      ) : activeView === 'feed' ? (
        <div className={layout.mainDashboardhome}>
          <div className={layout.mainhome}>
            <Feed />
          </div>
          <div className={layout.righthome}>
            <Chat />
          </div>
        </div>
      ) : (
        <div className={layout.shortlistView}>
          <WeeklyShortlist />
        </div>
      )}
    </div>
  )
}

export default DashHome
